import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import e from "../Color.js";
import { clone as r } from "../core/lang.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as s } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
import { collectField as p } from "../layers/support/fieldUtils.js";
import n from "./Renderer.js";
import l from "./support/HeatmapColorStop.js";

var _a;

var m = _a = /*#__PURE__*/function (_n) {
  _inherits(a, _n);

  var _super = _createSuper(a);

  function a(t) {
    var _this;

    _classCallCheck(this, a);

    _this = _super.call(this, t), _this.blurRadius = 10, _this.colorStops = [new l({
      ratio: 0,
      color: new e("rgba(255, 140, 0, 0)")
    }), new l({
      ratio: .75,
      color: new e("rgba(255, 140, 0, 1)")
    }), new l({
      ratio: .9,
      color: new e("rgba(255, 0,   0, 1)")
    })], _this.field = null, _this.fieldOffset = 0, _this.maxPixelIntensity = 100, _this.minPixelIntensity = 0, _this.type = "heatmap";
    return _this;
  }

  _createClass(a, [{
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e) {
        var r;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                r = this.field;
                r && "string" == typeof r && p(t, e, r);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function collectRequiredFields(_x, _x2) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }, {
    key: "getAttributeHash",
    value: function getAttributeHash() {
      return null;
    }
  }, {
    key: "getMeshHash",
    value: function getMeshHash() {
      return "".concat(JSON.stringify(this.colorStops), ".").concat(this.blurRadius, ".").concat(this.field);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _a({
        blurRadius: this.blurRadius,
        colorStops: r(this.colorStops),
        field: this.field,
        maxPixelIntensity: this.maxPixelIntensity,
        minPixelIntensity: this.minPixelIntensity
      });
    }
  }]);

  return a;
}(n);

t([o({
  type: Number,
  json: {
    write: !0
  }
})], m.prototype, "blurRadius", void 0), t([o({
  type: [l],
  json: {
    write: !0
  }
})], m.prototype, "colorStops", void 0), t([o({
  type: String,
  json: {
    write: !0
  }
})], m.prototype, "field", void 0), t([o({
  type: Number,
  json: {
    write: {
      overridePolicy: function overridePolicy(t, e, r) {
        return {
          enabled: null == r
        };
      }
    }
  }
})], m.prototype, "fieldOffset", void 0), t([o({
  type: Number,
  json: {
    write: !0
  }
})], m.prototype, "maxPixelIntensity", void 0), t([o({
  type: Number,
  json: {
    write: !0
  }
})], m.prototype, "minPixelIntensity", void 0), t([s({
  heatmap: "heatmap"
})], m.prototype, "type", void 0), m = _a = t([i("esri.renderers.HeatmapRenderer")], m);
var c = m;
export { c as default };